export const replaceSpacesWithDashes = (str: string) => str.replace(/\s+/g, '-');
